import DPIntroCore, {
	LAYER_CLASSES, EVENTS
} from './DPIntroCore';
import BulletsAnimation from '../../../../includes/assets/js/modules/BulletsAnimation';
import {
	$S,
	i18n
} from '../utils/dp-utils';
import IsSupportedBrowser from '../../../../includes/assets/js/modules/IsSupportedBrowser';
import Color from 'color';
import DPColors from '../../../../includes/assets/js/modules/DPColors';
import DPIncUtils from '../../../../includes/assets/js/modules/DPIncUtils';
import DPUserVisitCounter from './DPUserVisitCounter';



const SCROLL_SPEED_0_MS = 1000;
const SCROLL_MAX_TIME_COEF = 3;



export default class DPIntroTour {

	constructor(mainCfg, tourCfg) {
		if (mainCfg.dpDebugEn) {
			console.log('DPIntroTour');
			console.log('jQuery v: ' + jQuery.fn.jquery);
		}
		this.tourCfg = tourCfg;
		this.mainCfg = mainCfg;
		this.tourId = null;
		if (this.tourCfg) {
			this.tourCfg.text_styles = { ...this.mainCfg.text_styles, ...this.tourCfg.text_styles };
			this.tourId = this.tourCfg.tourId;
		}

		this.currentUrl = new URL(window.location);
		this.hookOptions = {
			tourId: this.tourId,
			currentUrl: this.currentUrl
		};
		if (this.shouldInitialize()) {
			this.initWrapperLayer();
			this.initBulletsAnimation();
			if (this.tourCfg) {
				this.updateTheme();
				this.initTriggers();
				this.initCore();
				this.initTour();
			}
		}
	}

	stepCoreToHookStep(stepCore) {
		if (!stepCore) return null;
		return {
			index: stepCore.step,
			tooltipContent: stepCore.intro,
			tooltipPosition: stepCore.position || 'auto',
			element: stepCore.isDummyElement ? null : stepCore.element,
			selector: stepCore.selector,
			isEnabledInteraction: stepCore.enable_interaction.val == 1,
		};
	}

	shouldInitialize() {
		const shouldInit = window.DpitHooks ? DpitHooks.apply_filters('shouldInit', true, this.hookOptions) : true;
		const diviBuilderMode = this.currentUrl.searchParams.get('et_fb') === '1';
		const oxygenBuilderMode = this.currentUrl.searchParams.get('ct_builder') === 'true';
		return !(diviBuilderMode || oxygenBuilderMode) && IsSupportedBrowser.isSupported() && shouldInit;
	}

	initBulletsAnimation() {
		this.bulletsAnimation = new BulletsAnimation(
			'.' + LAYER_CLASSES.overlayContainer,
			`fullscreen-bullets-anim-${this.tourId}`,
			[LAYER_CLASSES.bullets, `${LAYER_CLASSES.bullets}--fullscreen`], 10, 100);
	}

	initTriggers() {
		this.triggers = [];
		this.tourCfg.triggers.forEach((triggerCfg, idx) => {
			this.triggers.push({
				idx: idx,
				config: triggerCfg,
				jElement: (triggerCfg.selector === 'window') ? $(window) : $S(triggerCfg.selector),
				isInRun: false,
				wasRunInThisSession: false
			});
		});
		this.activeTriggerIdx = 0;
	}

	initWrapperClass() {
		$(this.dpIntroWrapper).addClass('dpintro-wrapper');
		const tourIdWrapper = this.getTourIdPostfix('dpintro-wrapper');
		$(this.dpIntroWrapper).addClass(tourIdWrapper);
		$(this.dpIntroWrapper).attr('id', tourIdWrapper);
	}

	initWrapperLayer() {
		this.dpIntroWrapper = document.createElement('div');
		this.initWrapperClass();

		document.body.appendChild(this.dpIntroWrapper);

		this.dpIntroMain = document.createElement('div');
		$(this.dpIntroMain).addClass(LAYER_CLASSES.main);
		this.dpIntroWrapper.appendChild(this.dpIntroMain);

		setTimeout(() => {
			this.actualizeDpWrapperSize();
		}, 150);
	}

	actualizeDpWrapperSize() {
		$(this.dpIntroWrapper).height($(document).height());
		$(this.dpIntroWrapper).width($('body').innerWidth());
	}

	isOnLoadTrigger(trigger) {
		return trigger.config.on == 'load' || this.shouldAlwaysRunOnLoad();
	}

	shouldAlwaysRunOnLoad() {
		return DPIncUtils.getDpUrlParam('dp_qp_run_always_on_load', this.mainCfg.queryParamsDefs, this.currentUrl) === '1';
	}

	shouldRunAtCurrentDevice() {
		return true;
	}

	initTourWithSelectedTrigger(trigger) {
		let run = true;
		var visitedCnt = DPUserVisitCounter.getVisitCount(this.mainCfg, trigger.config.allow_just_for_logged_in_users);

		if (trigger.config.first_user_visit_only) {
			let limit = trigger.config.first_n_user_visit || 1;
			run = (visitedCnt <= limit);
		}
		if (trigger.config.allow_just_for_logged_in_users && this.mainCfg.currentUserId == 0) {
			run = false;
		}
		if (trigger.config?.disable_for_roles?.length && this.mainCfg.currentUserRoles && this.mainCfg?.currentUserRoles?.length) {
			for (const val of trigger.config.disable_for_roles) {
				if (this.mainCfg.currentUserRoles.includes(val)) {
					run = false;
					break;
				}
			}
		}

		if (!this.shouldRunAtCurrentDevice(trigger)) run = false;

		if (run || this.shouldAlwaysRunOnLoad()) {
			if (this.isOnLoadTrigger(trigger)) {
				this.startTourWithAnimation(trigger);
			} else {
				if (!trigger.config.once_per_session_only || !trigger.wasRunInThisSession) {
					setTimeout(() => {
						this.activateTrigger(trigger);
					}, 300);
				}
			}
		}
	}

	initTour() {
		this.triggers.forEach((trigger) => {
			this.initTourWithSelectedTrigger(trigger);
		});
	}

	activateTrigger(trigger) {
		if (!this.isOnLoadTrigger(trigger)) {
			trigger.jElement.on(trigger.config.on, (event) => {
				let start = true;
				if (trigger.config.specific_key_pressed && event) {
					if (trigger.config.on === 'keydown' ||
						trigger.config.on === 'keypress' ||
						trigger.config.on === 'keyup') {
						start = trigger.config.specific_key_pressed == event.keyCode;
					}
				}
				if (start) {
					if (this.startTour(trigger) && event) {
						event.preventDefault();
						event.stopPropagation();
					}
				}
			});
		}
	}

	createCoreInstance() {
		return new DPIntroCore(this.dpIntroMain, this.mainCfg.dpDebugEn);
	}

	afterIntroCoreInit() {

	}

	initCore() {
		this.introCore = this.createCoreInstance();
		this.steps = this.initPreprocessSteps();
		this.afterIntroCoreInit();
		if (this.mainCfg.dpDebugEn) console.log('ROW STEPS', this.steps);
		if (this.steps && this.isStepsEnough2Start()) {

			this.introCore.setOptions(this.getIntroCoreOptions());
		}
		this.introCore.subscribeEvent(EVENTS.onExit, (core, reason) => {
			this.onExit(core, reason);
		});
		this.introCore.subscribeEvent(EVENTS.onAfterChange, (core, currentStepCore) => {
			if (window.DpitHooks) DpitHooks.do_action('afterStepChange', {
				...this.hookOptions,
				currentStepObj: this.stepCoreToHookStep(currentStepCore)
			});
		});
		this.introCore.subscribeEvent(EVENTS.onBeforeChange, (core, nextStep, backward, currentStep) => {
			if (window.DpitHooks) DpitHooks.do_action('beforeStepChange', {
				...this.hookOptions,
				currentStepObj: this.stepCoreToHookStep(currentStep),
				nextStepObj: this.stepCoreToHookStep(nextStep),
				isBackwardDirection: backward
			});

		});

		this.introCore.subscribeEvent(EVENTS.onResize, () => {
			this.actualizeDpWrapperSize();
		});
	}



	initPreprocessSteps() {
		let steps = $.parseJSON(this.tourCfg.steps);
		if (steps) {
			steps = steps.map((step) => {
				const preprocessedStep = {};
				Object.keys(step).forEach(paramName => {
					preprocessedStep[paramName] = DPIncUtils.decodeStepParamAdvancedVal(step[paramName], paramName, this.mainCfg.stepDefinitions, true, true);
				});
				return preprocessedStep;
			});
		}
		return steps;
	}

	getIntroCoreOptions() {
		return {
			steps: this.steps,
			scrollToElement: true,
			scrollTo: 'all',
			enable_interaction: '0',
			showStepNumbers: this.tourCfg.showStepNumbers,
			showProgress: this.tourCfg.showProgress,
			showBullets: this.tourCfg.showBullets,
			nextLabel: `${this.tourCfg.labeling.nextLabel || i18n('next', this.mainCfg.i18n)} &rarr;`,
			prevLabel: `&larr; ${this.tourCfg.labeling.prevLabel || i18n('back', this.mainCfg.i18n)}`,
			skipLabel: this.tourCfg.labeling.skipLabel || i18n('skip', this.mainCfg.i18n),
			doneLabel: this.tourCfg.labeling.doneLabel || i18n('done', this.mainCfg.i18n),
			exitOnOverlayClick: this.tourCfg.behaviour.exitOnOverlayClick,
			hide_previous_step_button: this.tourCfg.behaviour.hide_previous_step_button,
			hideNextAlways: this.tourCfg.behaviour.hideNextAlways,
			hide_skip_button: this.tourCfg.behaviour.hide_skip_button,
			overlayBlurred: this.tourCfg.behaviour.overlayBlurred,
			disable_navigation_by_bullets: this.tourCfg.behaviour.disable_navigation_by_bullets,
			max_tooltip_width: this.tourCfg.behaviour.max_tooltip_width,
			skip_absent_ref_el: this.tourCfg.behaviour.skip_absent_ref_el,
			customTextStylesEn: !$.isEmptyObject(this.mainCfg.text_styles),
			...this._getScrollSpeed(this.tourCfg.behaviour.scrollSpeed),
		};
	}

	_getScrollSpeed(cfgScrollSpeed) {
		const cfgScrollSpeedSanitized = Math.max(Math.min(cfgScrollSpeed, 100), 0);
		const scrollSpeedPerPageMs = cfgScrollSpeedSanitized === 100 ?
			0 :
			0.0802 * Math.pow(cfgScrollSpeedSanitized, 2) - 18.01 * cfgScrollSpeedSanitized + SCROLL_SPEED_0_MS;
		return {
			scrollSpeedPerPageMs: scrollSpeedPerPageMs,
			maxScrollSpeedPerPageMs: scrollSpeedPerPageMs * SCROLL_MAX_TIME_COEF
		};
	}

	isInRun() {
		return $(document.documentElement).hasClass('tour-intro');
	}

	isThisInRun() {
		return this.isInRun() && $(this.dpIntroWrapper).hasClass('dpintro-wrapper--running');
	}

	getTourIdPostfix(prefix = 'tour-intro') {
		return `${prefix}-${this.tourId}`;
	}

	isStepsEnough2Start() {
		return this.steps.length > 0;
	}


	updateTheme() {
		this.initWrapperClass();
		if (this.tourCfg && this.tourCfg.theme) {
			$(this.dpIntroWrapper).addClass(this.tourCfg.theme);
		}
		this.setAccentColor(this.tourCfg.accentColor);
		this.setRadiuses(this.tourCfg);
		DPIncUtils.setTextStyles(this.dpIntroWrapper, this.tourCfg?.text_styles, this.mainCfg?.mobile_break_points?.mobile);
	}

	setRadiuses() {
		if (this.tourCfg.tooltip_radius >= 0) {
			this.dpIntroWrapper.style.setProperty('--tooltip-border-radius', this.tourCfg.tooltip_radius + 'px');
		}
		if (this.tourCfg.highlight_radius >= 0) {
			this.dpIntroWrapper.style.setProperty('--highlight-border-radius', this.tourCfg.highlight_radius + 'px');
		}
		if (this.tourCfg.button_radius >= 0) {
			this.dpIntroWrapper.style.setProperty('--button-border-radius', this.tourCfg.button_radius + 'px');
			this.dpIntroWrapper.style.setProperty('--button-border-radius-sm', 0.3 * this.tourCfg.button_radius + 'px');
		}
	}


	adjustBulletsAnimationSizeVar() {
		if (this.tourCfg.behaviour.bulletAnimSize) {
			const size1Bullet = this.tourCfg.behaviour.bulletAnimSize / 14; // include gap
			this.dpIntroWrapper.style.setProperty('--bullet-anim-size', `${size1Bullet}vw`);
			this.dpIntroWrapper.style.setProperty('--bullet-anim-gap', `${size1Bullet / 6}vw`);
		}
	}

	adjustContrastToOverlayVar() {
		if (this.tourCfg.behaviour.overlayBlurred) {
			this.dpIntroWrapper.style.setProperty('--dpit-shadow-color', '30, 30, 30');
			this.dpIntroWrapper.style.setProperty('--dpit-shadow-alpha', 0);

		} else {
			let overlayColorProps = getComputedStyle(this.dpIntroWrapper).getPropertyValue('--overlay-bg-color');
			if (overlayColorProps) overlayColorProps = `rgb(${overlayColorProps})`;
			if (this.introCore && this.introCore.overlayLayer) overlayColorProps = getComputedStyle(this.introCore.overlayLayer).getPropertyValue('background-color');
			if (overlayColorProps) {
				const overlayColor = Color.rgb(overlayColorProps);
				if (overlayColor) {
					const contrastColor = DPColors.getContrastColor(overlayColor, ['#000', '#fff'], 3, ['#000']);
					if (contrastColor) {
						this.dpIntroWrapper.style.setProperty('--dpit-shadow-color', `${contrastColor.red()}, ${contrastColor.green()}, ${contrastColor.blue()}`);

						let shadowVertOffSign = '';
						let alpha = 0.35;
						if (contrastColor.isLight()) {
							shadowVertOffSign = '-';
							alpha = 0.25;
						}
						this.dpIntroWrapper.style.setProperty('--dpit-shadow-alpha', alpha);
						this.dpIntroWrapper.style.setProperty('--dpit-shadow-off-S', `${shadowVertOffSign}1px 1px`);
						this.dpIntroWrapper.style.setProperty('--dpit-shadow-off-M', `${shadowVertOffSign}2px 2px`);
						this.dpIntroWrapper.style.setProperty('--dpit-shadow-off-L', `${shadowVertOffSign}3px 2px`);
					}
				}
			}
		}
	}

	setAccentColor(accentColor) {
		if (!accentColor) accentColor = this.tourCfg.accentColor;
		if (accentColor) {
			const accent = Color.rgb(accentColor);
			if (accent) {
				this.currentAccentColor = `${accent.red()}, ${accent.green()}, ${accent.blue()}`;
				this.dpIntroWrapper.style.setProperty('--accent-color', this.currentAccentColor);
				const accentContrastColor = DPColors.getContrastColor(accentColor);
				if (accentContrastColor) {
					this.dpIntroWrapper.style.setProperty('--accent-contrast-color', `${accentContrastColor.red()}, ${accentContrastColor.green()}, ${accentContrastColor.blue()}`);
					const accentContrastInvColor = DPColors.getContrastColor(accentContrastColor);
					if (accentContrastInvColor) {
						this.dpIntroWrapper.style.setProperty('--accent-contrast-inv-color', `${accentContrastInvColor.red()}, ${accentContrastInvColor.green()}, ${accentContrastInvColor.blue()}`);
					}
				}
			}
		} else {
			this.currentAccentColor = '';
			this.dpIntroWrapper.style.removeProperty('--accent-color');
			this.dpIntroWrapper.style.removeProperty('--accent-contrast-color');
		}
		this.adjustContrastToOverlayVar();
		this.adjustBulletsAnimationSizeVar();
	}

	setAsRunningTour() {
		if (!this.isThisInRun()) {
			if (!window.DpitApi) window.DpitApi = {
				'goToNext': () => this.introCore.goToNextStep(),
				'goToPrev': () => this.introCore.goToPreviousStep(),
				'goToStep': (stepIdx) => this.introCore.goToStep(stepIdx),
				'exit': () => this.introCore._exitIntro('skip'),
				'setAccent': (color) => this.setAccentColor(color),
				'getScrollSpeed': () => this.tourCfg?.behaviour?.scrollSpeed,
				'setScrollSpeed': (speedToSet) => this.introCore.setOptions(this._getScrollSpeed(speedToSet)),
				'setCoreOptions': (options) => this.introCore.setOptions(options)
			};
			$(this.dpIntroWrapper).addClass('dpintro-wrapper--running');
			$(document.documentElement).addClass(this.getTourIdPostfix('tour-intro'));
			$(document.documentElement).addClass('tour-intro');
			if (window.DpitHooks) DpitHooks.do_action('started', this.hookOptions);
		}
	}

	resetAsRunningTour() {
		$(this.dpIntroWrapper).removeClass('dpintro-wrapper--running');
		$(document.documentElement).removeClass(this.getTourIdPostfix('tour-intro'));
		$(document.documentElement).removeClass('tour-intro');
		if (window.DpitHooks) DpitHooks.do_action('ended', this.hookOptions);
		window.DpitApi = null;
	}

	startTourWithAnimation(trigger, step = 0, forceStart = false, backward = false, animationTimeMs = 1000) {
		if (!this.tourCfg.behaviour.disableStartAnimation) {
			if (this.isStepsEnough2Start() && !this.isInRun()) {
				this.setAsRunningTour();
				this.introCore.addOverlayLayer(false, this.tourCfg.behaviour.overlayBlurred);
				this.bulletsAnimation.createAndRun(backward, this.introCore.overlayContainer);
				setTimeout(() => {
					this.bulletsAnimation.destroy();
					this.startTour(trigger, step, forceStart, true);
					this.adjustContrastToOverlayVar();
				}, animationTimeMs);
			}
		} else this.startTour(trigger, step, forceStart);
	}

	startTour(trigger, step = 0, forceStart = false, disableIsInRunCheck = false) {

		if (this.isStepsEnough2Start() && (!this.isInRun() || disableIsInRunCheck) && (forceStart || !trigger.config.once_per_session_only || !trigger.wasRunInThisSession)) {
			this.setAsRunningTour();
			this.hideElementsAtStart();
			trigger.isInRun = true;

			this.introCore.start(step, this.isInitializedBackward());
			if (this.mainCfg.dpDebugEn) console.log('Starting tour: ', this.tourCfg.tourName + ' (' + this.tourId + ')');
			trigger.wasRunInThisSession = true;
			this.activeTriggerIdx = trigger.idx;
			return true;
		}
		return false;
	}

	isInitializedBackward() {
		return false;
	}

	hideElementsAtStart() {
		if (this.tourCfg.hideElementsAtStart) {
			setTimeout(() => {
				const jHideEl = $S(this.tourCfg.hideElementsAtStart);
				if (jHideEl && jHideEl.length) {
					jHideEl.each((idx, element) => {
						$(element).addClass('dpit-hidden-at-start').fadeOut(400);
					});
				}
			}, 1000);
		}
	}

	showHiddenElementsAtStart() {
		$('.dpit-hidden-at-start').fadeIn(400).removeClass('dpit-hidden-at-start');
	}

	onExit(core, reason) {
		if (this.mainCfg.dpDebugEn) console.log('Exiting tour: ' + this.tourId + ' - reason: ' + reason);
		this.showHiddenElementsAtStart();
		this.triggers[this.activeTriggerIdx].isInRun = false;
		this.resetAsRunningTour();
		if (window.DpitHooks) DpitHooks.do_action('afterTourExited', {
			...this.hookOptions,
			reason: reason
		});
	}

}